(ns iris.login.views
  (:require
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]
   [iris.login.events :as events]
   [iris.login.subs :as subs]
   ["firebase/app" :as firebase]
  ;;  [herb.core :refer [<class <id]]
   [iris.login.styles :as $login]
   [iris.common :as common]
   [iris.globals :as globals]))


(defn error-message []
  (let [message (re-frame/subscribe [::subs/error-message])]
    [:p.text-center {:style {:color "red" :font-weight "bold" :margin "10px 0"}} @message]))

(defn success-message []
  (let [message (re-frame/subscribe [::subs/success-message])]
    [:p.text-center {:style {:color "darkgreen" :font-weight "bold" :margin "10px 0"}} @message]))


(defn login-reset-form []
  (let [username (reagent/atom "")
        password (reagent/atom "")
        new-password (reagent/atom "")
        new-password-2 (reagent/atom "")]
    [:form {:class
            ;; (<class $login/form-signin)
            $login/$form-signin
            }
     [:input.form-control
      {:class
      ;;  (<class $login/username-input-box)
       $login/$username-input-box
       :autoFocus true
       :required true
       :placeholder "Username"
       :type "text"
       :on-change (fn [e] (reset! username (-> e .-target .-value)))}]
     [:input.form-control
      {:class
      ;;  (<class $login/password-input-box)
       $login/$password-input-box
       :required true
       :placeholder "Password"
       :type "password"
       :on-change (fn [e] (reset! password (-> e .-target .-value)))}]

     [:input.form-control
      {:class
      ;;  (<class $login/username-input-box)
       $login/$username-input-box
       :required true
       :placeholder "New Password"
       :type "password"
       :on-change (fn [e] (reset! new-password (-> e .-target .-value)))}]
     [:input.form-control
      {:class
      ;;  (<class $login/password-input-box)
       $login/$password-input-box
       :required true
       :placeholder "Confirm New Password"
       :type "password"
       :on-change (fn [e] (reset! new-password-2 (-> e .-target .-value)))}]
     [:button.btn.btn-lg.btn-primary
      {:class
      ;;  (<class $login/btn-block)
       $login/$btn-block
       :type "submit"
       :on-click (fn [e]
                   (when (and (not-empty @username)
                              (not-empty @password)
                              (not-empty @new-password)
                              (not-empty @new-password-2))
                     (.preventDefault e)

                     (if (not= @new-password @new-password-2)
                       (re-frame/dispatch [::events/set-login-error-message "The password confirmation does not match."])
                       (re-frame/dispatch [::events/change-password @username @password @new-password]))))}
      "\n                    Reset Password"]]))


(defn login-form []
  ;; (.log js/console "FIREBASE GET APPS" (-> firebase .-apps .-length))
  (reagent/with-let [username (reagent/atom "")
                     password (reagent/atom "")
                     linger (reagent/atom @globals/linger)]
    [:form {:class
            ;; (<class $login/form-signin)
            $login/$form-signin
            }
     [:input.form-control
      {:class
      ;;  (<class $login/username-input-box)
       $login/$username-input-box
       :autoFocus true
       :required true
       :placeholder "Username"
       :type "text"
       :on-change (fn [e] (reset! username (-> e .-target .-value)))}]
     [:input.form-control
      {:class
      ;;  (<class $login/password-input-box)
       $login/$password-input-box
       :required true
       :placeholder "Password"
       :type "password"
       :on-change (fn [e] (reset! password (-> e .-target .-value)))}]
     [:button.btn.btn-lg.btn-primary
      {:class
      ;;  (<class $login/btn-block)
       $login/$btn-block
       :type "submit"
       :on-click (fn [e]
                   (when (and (not-empty @username) (not-empty @password))
                     (.preventDefault e)
                     (re-frame/dispatch [::events/login @username @password @linger])))}
      "\n                    Sign in"]
     [:label.checkbox {:class
                      ;;  (<class $login/checkbox)
                       $login/$checkbox
                       }
      [:input {:type "checkbox"
               :default-checked @linger
               :on-change (fn [e] (reset! linger (-> e .-target .-checked)))}]
      "Remember me"]
     [:span "Uncheck if you are on a public device"]]))


(defn login-panel []
  (let [login-reset-needed (re-frame/subscribe [::subs/login-reset-needed])
        logged-in?         (re-frame/subscribe [::subs/logged-in?])]
    [:div.container
     [common/spinner]
     (if @logged-in?
       [:div.row
        [:div.col-sm-6.col-md-6.col-sm-offset-3.text-center {:class "alert alert-success" :style {:margin-top "20px"}} "You are logged in, click " [:a {:href "/"} "here"] " to continue to Iris."]]
       [:div.row
        [:div.col-sm-6.col-md-6.col-sm-offset-3
         [:h1.text-center
          {:class
          ;;  (<class $login/login-title)
           $login/$login-title
           }
          (if (true? @login-reset-needed) "Reset Account Password" "Sign in to continue")]
         [:div {:class
                ;; (<class $login/account-wall)
                $login/$account-wall
                }
          (if (true? @login-reset-needed)
            [login-reset-form]
            [login-form])]
         [error-message]
         [success-message]]])]))